import { sizeQueryOperatorEnum } from '@/global/enum'
import { onlyIntegerCustomProps } from './constraint'

export const SizeQueryList = (keyName: string) => {
  return FormItemData(keyName).filter((item) => item.type === 'SizeQuery')
}

// 接口接受参数
export type formName =
  | 'schemeId' // 方案id
  // MPM v5.0.0 项目商品池（固定 7 项业务筛选）
  | 'poolProductCode' // 咸亨编码
  | 'poolCustomerTitle' // 客户标题
  | 'poolBrandName' // 品牌名称
  | 'poolCategoryName' // 类目名称
  | 'poolRemark' // 备注
  | 'poolStandardCode' // 标准库编码/产品编码
  | 'poolMaterialCode' // 物资编码
  // 3.0.0 模块筛选
  | 'contractStartDate'
  | 'contractEndDate'
  | 'enterpriseName'
  | 'contractNum'
  | 'isFile'
  | 'contractStatus'
  | 'enterpriseLevel'
  | 'uploadStartDate'
  | 'uploadEndDate'
  | 'productName'
  | 'model'
  | 'offererName'
  | 'offererPhone'
  | 'inquiryStartDate'
  | 'inquiryEndDate'
  | 'inquirer'
  | 'brands'
  | 'mettingName'
  | 'personnel'
  | 'depart'
  | 'deptCode'
  | 'name'
  | 'erpOrgCode'
  | 'startDate'
  | 'endDate'
  | 'purchaserName'
  | 'purchaser'
  | 'level'
  | 'contacts'
  | 'mobile'
  | 'industry'
  | 'enterpriseNature'
  | 'erpState'
  | 'erpCode'
  | 'state'
  | 'country'
  | 'manageBrand'
  | 'uscc'
  | 'corporate'
  | 'applyStartDate'
  | 'applyEndDate'
  | 'applyType'
  | 'checkMan'
  | 'auditStartDate'
  | 'auditEndDate'
  | 'checkState'
  | 'realName'
  | 'mail'
  | 'brand'
  | 'code'
  | 'brandName'
  | 'isPermission'
  | 'manageType'
  | 'authorizationType'
  | 'fileName'
  | 'supplierName'
  | 'batchNumber'
  | 'ossConn'
  | 'tempCode'
  // 4.0.0新增
  // 订单履约模块
  | 'address' // 收货地址
  | 'consignee' // 收件人
  | 'customer' // 客户名称
  //   | 'endDate'
  | 'invoicingState' // 开票状态
  //   | 'mobile'
  | 'orderNo' // 客户订单号
  | 'orderState' // 订单状态
  | 'platform' // 下单平台
  // 5.0.0 电商供应商订单
  | 'customerPayback' // 客户回款
  | 'signVoucher' // 签收凭证
  | 'orderRemark'
  // 7.8.0
  | 'overdueType' // 订单超期
  //   | 'startDate'
  //   | 'supplierId'
  // 退货模块
  | 'orderReturnNo'
  | 'returnCount'
  | 'returnPrice'
  | 'returnApplyDate'
  // | 'returnState'
  | 'returnType'
  | 'returnApplyStartDate'
  | 'returnApplyEndDate'
  // 报备单管理
  | 'filingArriveStartTime'
  | 'filingArriveEndTime'
  | 'filingStartTime'
  | 'filingEndTime'
  | 'filingNo'
  | 'filingOrderStartTime'
  | 'filingOrderEndTime'
  | 'fillingState'
  | 'num'
  | 'platform'
  | 'price'
  // 对账单
  | 'accountStartTime'
  | 'accountEndTime'
  | 'accountNo'
  | 'accountState'
  | 'accountPrice'
  | 'orderStartTime'
  | 'orderEndTime'
  | 'settlePrice'
  // 供应商订单
  | 'supplierOrderCode'
  | 'supplierOrderEndTime'
  | 'supplierOrderGroupName'
  | 'supplierOrderReceiveMan'
  | 'supplierOrderStartTime'
  | 'supplierDirectShipment'
  // 退货
  | 'supplierOrderReturnCode'
  | 'supplierOrderReturnGroupName'
  | 'upplierOrderReturnReceiveMan'
  | 'supplierOrderReturnNumber'
  | 'supplierOrderReturnReceiveMan'
  | 'supplierOrderReturnStartTime'
  | 'supplierOrderReturnEndTime'
  | 'supplierOrderDirectShipment'
  // 消息中心
  | 'content'
  | 'messageType'
  // 5.0.0开票
  | 'logisticsNum'
  | 'title' // 发票抬头
  | 'invoiceType' // 发票类型
  // 开票-申请时间
  | 'createTimeBegin'
  | 'createTimeEnd'
  | 'accountStatus' // 对账状态
  | 'accountOpenInvoiceStatus' // 电商供应商订单-供应商开票状态
  | 'paymentStatus' // 付款状态
  | 'paymentNo' // 付款单号
  // 付款单
  | 'orderTimeStart'
  | 'orderTimeEnd'
  | 'paymentRequestEndTime'
  | 'paymentRequestStartTime'
  // 订单数
  | 'orderCount'
  | 'submitMan'
  | 'enterPriseName'
  | 'invoiceApplicationNum'
  // 待提交物料
  | 'mainPicture'
  | 'detailsPicture'
  | 'extendedAttribute'
  | 'relevancyPlatform'
  | 'srmProductType' // 物料类型
  | 'unitCode'
  // 关联项目
  | 'platformCodes'
  | 'srmPlatformCodes'
  | 'referenceSupplyPrice'
  // 5.6.0
  | 'filingType' // 报备单类型
  // 5.7.2 我的品牌
  | 'brandCode'
  | 'brandNameCn'
  | 'brandNameEn'
  | 'mpmState'
  | 'announcementTitle'
  | 'invoiceNum'
  | 'invoiceState'
  | 'receiveMan'
  | 'proName'
  | 'productCode'
  | 'gwCode'
  | 'spuModel'
  | 'gwProductSerialNumber'
  | 'categoryName'
  | 'orderSource'
  | 'supplierOpenInvoiceState' // 供应商订单-供应商开票状态
  | 'contractType'
  | 'createTimeStart'
  | 'createTimeFinish'
  | 'enterpriseCode'
  | 'signatureStatus'
  | 'signingType'
  | 'landingContractStatus'
  | 'secondSigningSupplierId'
  // 我的物料
  | 'firstPassStart' // 咸亨上架时间
  | 'firstPassEnd'
  | 'startWriteOffTime'
  | 'endWriteOffTime'
  | 'paymentTypeName'
  | 'manuCode'
  | 'dispatchTimeStart'
  | 'dispatchTimeEnd'
  | 'reportStartTime'
  | 'reportEndTime'
  | 'materialCode'
  | 'reportType'
  | 'projectCode'
  | 'auditStartTime'
  | 'auditEndTime'
  | 'materialCodes'
  | 'reportCode'
  | 'invoiceNature'
  | 'returnOrderNo'
  | 'blueInvoiceNum'
  | 'returnNo'
  | 'customerName'
  | 'platformCode'
  | 'titleOfTheContract'
  | 'returnTime'
  | 'returnStartTime'
  | 'returnEndTime'
  // 询价单
  | 'inquiryNo'
  | 'groupName'
  | 'startExpireDate'
  | 'endExpireDate'
  | 'materialCount'
  | 'status'
  | 'itemStatus'
  | 'inquiryTaskNo'
  | 'clientMaterialName'
  | 'clientMaterialQty'
  | 'clientMaterialQtyOperator'
  | 'quotationTimeStart'
  | 'quotationTimeEnd'
  | 'creatorName'
  | 'startCreatedTime'
  | 'endCreatedTime'
  | 'startDeadlineTime'
  | 'endDeadlineTime'
  | 'submitTimeStart'
  | 'submitTimeEnd'
  | 'inquiryDateStart'
  | 'inquiryDateEnd'
  | 'inquiryDate'
  | 'submitTimeStart'
  | 'submitTimeEnd'
  // 1.6.0 项目物料模块（与 projectMaterial 查询接口字段名一致）
  | 'productCodes' // 咸亨SKU编码
  | 'customerSkuCodes' // 客户SKU编码
  | 'customerSpuCodes' // 客户SPU编码
  | 'customerMaterialCodes' // 客户物料编码
  | 'thirdOnShelf' // 客户平台状态
  | 'thirdOnShelfStartTime' // 状态变更开始时间
  | 'thirdOnShelfEndTime' // 状态变更结束时间
  | 'supplierOrderType'
  // 自营协议管理
  | 'contractNo'
  | 'firstSigningGroupName'
  | 'agreementSigningType'
  | 'agreementSignStatus'
  | 'agreementStatus'
  | 'effective'
  | 'effectiveStart'
  | 'effectiveEnd'
  | 'untilContractExpirationDays'
  | 'untilContractExpirationDaysOperators'

// 获取筛选条件data唯一key
export type EventNameType =
  | 'isFile'
  | 'contractStatus'
  | 'enterpriseLevel'
  | 'level'
  | 'industry'
  | 'enterpriseNature'
  | 'erpState'
  | 'state'
  | 'applyType'
  | 'checkState'
  | 'manageType'
  | 'isPermission'
  | 'authorizationType'
  | 'ossConn'
  // 4.0.0
  | 'invoicingState' // 订单履约 开票状态 下拉框
  | 'orderState' // 订单状态
  | 'platform'

  // 5.0.0 电商供应商订单
  | 'customerPayback' // 客户回款
  | 'signVoucher' // 签收凭证
  // 7.8.0
  | 'overdueType' // 订单超期
  // 退货单
  | 'returnType'
  | 'fillingState'
  | 'accountState' // 对账单状态
  | 'supplierDirectShipment'
  | 'messageType'
  | 'invoiceType'
  | 'accountStatus' // 对账状态
  | 'accountOpenInvoiceStatus' // 供应商开票状态
  | 'paymentStatus' // 付款状态
  | 'mainPicture' // 主图
  | 'detailsPicture' // 详情图
  | 'extendedAttribute' // 拓展属性
  | 'srmProductType' // 物料类型
  | 'unitCode'
  | 'platformCodes'
  | 'srmPlatformCodes'
  | 'referenceSupplyPrice'
  // 5.6.0
  | 'filingType' // 报备单类型
  | 'manageType'
  | 'mpmState'
  | 'announcementTitle'
  | 'invoiceState'
  | 'receiveMan'
  | 'orderSource'
  | 'supplierOpenInvoiceState'
  | 'contractType'
  | 'createTimeStart'
  | 'createTimeFinish'
  | 'enterpriseCode'
  | 'signatureStatus'
  | 'signingType'
  | 'landingContractStatus'
  | 'secondSigningSupplierId'
  | 'manuCode'
  | 'proName'
  | 'paymentStatusEnum'
  | 'reportType'
  | 'invoiceNature'
  | 'platformCode'
  | 'titleOfTheContract'
  | 'status' // 询价单状态
  | 'materialCountLevel' // 物料条数运算符
  | 'itemStatus' // 询价明细状态
  // 1.6.0 项目物料
  | 'thirdOnShelf' // 客户平台状态（接口 thirdOnShelf）
  | 'pmAuditStatus' // 项目物料-审核状态
  | 'pmReportType' // 项目物料-提报类型
  | 'supplierOrderType'
  // 自营协议管理
  | 'agreementSigningType'
  | 'agreementSignStatus'
  | 'agreementStatus'

export const TEXT = 'TEXT' // 输入型
export const Hidden = 'Hidden' // 选择型
export const DateTime = 'DateTime' // 时间范围型
export const SizeQuery = 'SizeQuery'
export type ItemParam = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x in EventNameType]?: any
} & {
  title: string // 名称
  name?: formName // name
  type: typeof TEXT | typeof DateTime | typeof Hidden | typeof SizeQuery // 类型
  event?: EventNameType // 事件对象
  hiddenName?: string // 显示的name字段
  startTimeName?: formName // 开始 日期范围标志 name
  endTimeName?: formName // 结束 日期范围标志 name
  range?: {
    operatorName: string // 运算符字段名
    selectEvent: string // 选择事件名
    contrastName: string // 对比值字段名
  } // 数字范围配置
  moduleTitle?: {
    [x in ScreenKey]?: string
  } // 根据模块区分要展示的名称
}
export const FormItemData = (keyName?: string) => {
  return [
    {
      title: '合同时间',
      type: DateTime,
      hiddenName: 'contractTime',
      startTimeName: 'contractStartDate',
      endTimeName: 'contractEndDate',
    },
    {
      name: 'enterpriseName',
      title: '供应商名称',
      type: TEXT,
    },
    {
      name: 'contractNum',
      title: '合同号',
      type: TEXT,
    },
    {
      name: 'enterpriseLevel',
      title: '供应商等级',
      type: Hidden,
      event: 'enterpriseLevel',
      hiddenName: 'enterpriseLevel',
    },
    {
      name: 'isFile',
      title: '附件状态',
      type: Hidden,
      event: 'isFile',
      hiddenName: 'isFile',
    },
    {
      name: 'contractStatus',
      title: '合同状态',
      type: Hidden,
      event: 'contractStatus',
      hiddenName: 'contractStatus',
    },
    {
      title: '上传时间',
      type: DateTime,
      hiddenName: 'time',
      startTimeName: 'uploadStartDate',
      endTimeName: 'uploadEndDate',
    },
    {
      name: 'productName',
      title: '商品名称',
      type: TEXT,
      moduleTitle: {
        PROJECTMATERIAL: '咸亨物料名称',
      },
    },
    {
      name: 'offererName',
      title: '报价人',
      type: TEXT,
    },
    {
      name: 'offererPhone',
      title: '报价人手机',
      type: TEXT,
    },
    {
      title: '询价时间',
      type: DateTime,
      hiddenName: 'enquiryTime',
      startTimeName: 'inquiryStartDate',
      endTimeName: 'inquiryEndDate',
    },
    {
      title: '询价日期',
      type: DateTime,
      hiddenName: 'quotationTime',
      startTimeName: 'quotationTimeStart',
      endTimeName: 'quotationTimeEnd',
    },
    {
      title: '询价日期',
      type: DateTime,
      hiddenName: 'inquiryDate',
      startTimeName: 'inquiryDateStart',
      endTimeName: 'inquiryDateEnd',
    },
    {
      name: 'inquirer',
      title: '询价人',
      type: TEXT,
    },
    {
      name: 'brands',
      title: '维护品牌',
      type: TEXT,
    },
    {
      name: 'mettingName',
      title: '会议名称',
      type: TEXT,
    },
    {
      name: 'personnel',
      title: '参会人员',
      type: TEXT,
    },
    {
      name: 'depart',
      title: 'SRM部门名称',
      type: TEXT,
    },
    {
      name: 'deptCode',
      title: 'SRM部门编码',
      type: TEXT,
    },
    {
      name: 'erpOrgCode',
      title: 'ERP组织编码',
      type: TEXT,
    },
    {
      name: 'realName',
      title: '姓名',
      type: TEXT,
    },
    {
      title: '下单时间',
      type: DateTime,
      hiddenName: 'createTime',
      startTimeName: 'startDate',
      endTimeName: 'endDate',
    },
    {
      name: 'purchaserName',
      title: '负责采购',
      type: TEXT,
      moduleTitle: {
        INQUIRYLIST: '采购员',
      },
    },
    {
      name: 'purchaser',
      title: '采购员',
      type: TEXT,
    },
    {
      name: 'erpCode',
      title: 'ERP编码',
      type: TEXT,
    },

    {
      name: 'contacts',
      title: '联系人',
      type: TEXT,
    },
    {
      name: 'mobile',
      title: '联系方式',
      type: TEXT,
    },
    {
      name: 'industry',
      title: '行业',
      type: Hidden,
      event: 'industry',
      hiddenName: 'industry',
    },
    {
      name: 'enterpriseNature',
      title: '供应商性质',
      type: Hidden,
      event: 'enterpriseNature',
      hiddenName: 'enterpriseNature',
    },
    {
      name: 'erpState',
      title: '同步ERP状态',
      type: Hidden,
      event: 'erpState',
      hiddenName: 'erpState',
    },
    {
      name: 'state',
      title: '前台',
      type: Hidden,
      event: 'state',
      hiddenName: 'state',
    },
    {
      name: 'country',
      title: '国家',
      type: TEXT,
    },
    {
      name: 'uscc',
      title: '统一社会信用代码',
      type: TEXT,
    },
    {
      name: 'manageBrand',
      title: '经营品牌',
      type: TEXT,
    },
    {
      name: 'corporate',
      title: '法人',
      type: TEXT,
    },
    {
      title: '申请时间',
      type: DateTime,
      hiddenName: 'applyTime',
      startTimeName: 'applyStartDate',
      endTimeName: 'applyEndDate',
    },
    {
      title: '审核时间',
      type: DateTime,
      hiddenName: 'auditTime',
      startTimeName: 'auditStartDate',
      endTimeName: 'auditEndDate',
    },
    {
      name: 'applyType',
      title: '申请类型',
      type: Hidden,
      event: 'applyType',
      hiddenName: 'applyType',
    },
    {
      name: 'checkState',
      title: '审核状态',
      type: Hidden,
      event: 'checkState',
      hiddenName: 'checkState',
    },
    {
      name: 'mail',
      title: '邮箱',
      type: TEXT,
    },
    {
      name: 'brand',
      title: '品牌',
      type: TEXT,
    },
    {
      name: 'brandName',
      title: '品牌名',
      type: TEXT,
    },
    {
      name: 'isPermission',
      title: '授权书',
      type: Hidden,
      event: 'isPermission',
      hiddenName: 'isPermission',
    },
    {
      name: 'manageType',
      title: '经营形式',
      type: Hidden,
      event: 'manageType',
      hiddenName: 'manageType',
    },
    {
      name: 'authorizationType',
      title: '授权类型',
      type: Hidden,
      event: 'authorizationType',
      hiddenName: 'authorizationType',
    },
    {
      name: 'fileName',
      title: '文件名',
      type: TEXT,
    },
    {
      name: 'code',
      title: '编码',
      type: TEXT,
    },
    {
      name: 'model',
      title: '规格型号',
      type: TEXT,
    },
    {
      name: 'manuCode',
      title: '规格型号',
      type: TEXT,
    },
    {
      name: 'name',
      title: '商品名称',
      type: TEXT,
      moduleTitle: {
        MATERIALPRICEADJUSTMENT: '物料名称',
        MATERIALCODEMODAL: '名称',
      },
    },
    {
      name: 'checkMan',
      title: '审核人',
      type: TEXT,
    },
    {
      name: 'ossConn',
      title: 'OSS上传',
      type: Hidden,
      event: 'ossConn',
      hiddenName: 'ossConn',
    },
    {
      name: 'supplierName',
      title: '供应商名称',
      type: TEXT,
    },
    {
      name: 'batchNumber',
      title: '批号',
      type: TEXT,
    },
    {
      name: 'tempCode',
      title: '编码',
      type: TEXT,
    },
    //   4.0.0订单履约模块
    {
      name: 'address',
      title: '收货地址',
      type: TEXT,
    },

    {
      name: 'consignee',
      title: '收件人',
      type: TEXT,
    },
    {
      name: 'customer',
      title: '客户名称',
      type: TEXT,
    },
    {
      name: 'invoicingState',
      title: '客户开票',
      type: Hidden,
      event: 'invoicingState',
      hiddenName: 'invoicingState',
    },
    {
      name: 'orderNo',
      title: '客户订单号',
      type: TEXT,
    },
    {
      name: 'orderState',
      title: '订单状态',
      type: Hidden,
      event: 'orderState',
      hiddenName: 'orderState',
    },
    {
      name: 'orderRemark',
      title: '客户备注',
      type: TEXT,
    },
    {
      name: 'overdueType',
      title: '订单超期',
      type: Hidden,
      event: 'overdueType',
      hiddenName: 'overdueType',
    },
    {
      name: 'platform',
      title: '项目名称',
      type: Hidden,
      event: 'platform',
      hiddenName: 'platform',
      moduleTitle: {
        MYINVOICE: '下单平台',
      },
    },
    {
      name: 'orderReturnNo',
      title: '退货订单号',
      type: TEXT,
    },
    {
      name: 'returnCount',
      title: '退货数量',
      type: TEXT,
    },
    {
      name: 'returnPrice',
      title: '退货金额',
      type: TEXT,
    },
    {
      name: 'returnType',
      title: '申请单类型',
      type: Hidden,
      event: 'returnType',
      hiddenName: 'returnType',
    },
    {
      title: '申请时间',
      type: DateTime,
      hiddenName: 'returnApplyDate',
      startTimeName: 'returnApplyStartDate',
      endTimeName: 'returnApplyEndDate',
    },
    {
      title: '到期日',
      type: DateTime,
      hiddenName: 'filingArriveTime',
      startTimeName: 'filingArriveStartTime',
      endTimeName: 'filingArriveEndTime',
    },
    {
      title: '报备时间',
      type: DateTime,
      hiddenName: 'filingTime',
      startTimeName: 'filingStartTime',
      endTimeName: 'filingEndTime',
    },
    {
      title: '咸亨上架时间',
      type: DateTime,
      hiddenName: 'firstPassTime',
      startTimeName: 'firstPassStart',
      endTimeName: 'firstPassEnd',
    },
    {
      title: '预计点单日',
      type: DateTime,
      hiddenName: 'filingOrderTime',
      startTimeName: 'filingOrderStartTime',
      endTimeName: 'filingOrderEndTime',
    },
    {
      name: 'filingNo',
      title: '报备单号',
      type: TEXT,
    },
    {
      name: 'fillingState',
      title: '报备单状态',
      type: Hidden,
      event: 'fillingState',
      hiddenName: 'fillingState',
    },
    {
      name: 'num',
      title: '数量',
      type: TEXT,
    },
    {
      name: 'price',
      title: '金额',
      type: TEXT,
    },
    {
      name: 'accountState',
      title: '对账单状态',
      type: Hidden,
      event: 'accountState',
      hiddenName: 'accountState',
    },
    {
      name: 'accountNo',
      title: '对账单号',
      type: TEXT,
    },
    {
      title: '申请时间',
      type: DateTime,
      hiddenName: 'accountApplyTime',
      startTimeName: 'accountStartTime',
      endTimeName: 'accountEndTime',
    },
    {
      name: 'accountPrice',
      title: '已回金额',
      type: TEXT,
    },
    {
      title: '下单时间',
      type: DateTime,
      hiddenName: 'orderDoneTime',
      startTimeName: 'orderStartTime',
      endTimeName: 'orderEndTime',
    },
    {
      title: '下单时间',
      type: DateTime,
      hiddenName: 'orderDoneTime2',
      startTimeName: 'orderTimeStart',
      endTimeName: 'orderTimeEnd',
    },
    {
      title: '派单时间',
      type: DateTime,
      hiddenName: 'dispatchTime',
      startTimeName: 'dispatchTimeStart',
      endTimeName: 'dispatchTimeEnd',
    },
    {
      name: 'settlePrice',
      title: '最终结算金额',
      type: TEXT,
    },
    {
      name: 'supplierOrderCode',
      title: '采购订单号',
      type: TEXT,
    },
    {
      title: '创建时间',
      type: DateTime,
      hiddenName: 'supplierOrderTime',
      startTimeName: 'supplierOrderStartTime',
      endTimeName: 'supplierOrderEndTime',
    },
    {
      name: 'supplierOrderGroupName',
      title: '采购组织',
      type: TEXT,
    },
    {
      name: 'supplierOrderReceiveMan',
      title: '收件人',
      type: TEXT,
    },
    {
      name: 'supplierDirectShipment',
      title: '是否厂直发',
      type: Hidden,
      event: 'supplierDirectShipment',
      hiddenName: 'supplierDirectShipment',
    },
    {
      name: 'supplierOrderReturnCode',
      title: '采购订单号',
      type: TEXT,
    },
    {
      name: 'paymentTypeName',
      title: '最新回款方式',
      type: TEXT,
    },
    {
      name: 'supplierOrderReturnGroupName',
      title: '采购组织',
      type: TEXT,
    },
    {
      name: 'supplierOrderReturnReceiveMan',
      title: '采购员',
      type: TEXT,
    },
    {
      name: 'supplierOrderReturnNumber',
      title: '单号',
      type: TEXT,
    },
    {
      name: 'supplierOrderDirectShipment',
      title: '是否厂直发',
      type: Hidden,
      event: 'supplierDirectShipment',
      hiddenName: 'supplierOrderDirectShipment',
    },
    {
      title: '创建时间',
      type: DateTime,
      hiddenName: 'supplierOrderReturnTime',
      startTimeName: 'supplierOrderReturnStartTime',
      endTimeName: 'supplierOrderReturnEndTime',
    },
    {
      title: '退货时间',
      type: DateTime,
      hiddenName: 'returnTime',
      startTimeName: 'returnStartTime',
      endTimeName: 'returnEndTime',
    },
    {
      title: '最新核销时间',
      type: DateTime,
      hiddenName: 'writeOffTime',
      startTimeName: 'startWriteOffTime',
      endTimeName: 'endWriteOffTime',
    },
    {
      name: 'content',
      title: '消息内容',
      type: TEXT,
    },
    {
      name: 'messageType',
      title: '消息类型',
      type: Hidden,
      event: 'messageType',
      hiddenName: 'messageType',
    },
    {
      name: 'signVoucher',
      title: '签收凭证',
      type: Hidden,
      event: 'signVoucher',
      hiddenName: 'signVoucher',
    },
    {
      name: 'customerPayback',
      title: '客户回款',
      type: Hidden,
      event: 'customerPayback',
      hiddenName: 'customerPayback',
    },
    {
      name: 'logisticsNum',
      title: '物流单号',
      type: 'TEXT',
    },
    {
      name: 'title',
      title: '发票抬头',
      type: 'TEXT',
      moduleTitle: {
        TODOLIST: '待办标题',
      },
    },
    {
      name: 'invoiceType',
      title: '发票类型',
      type: Hidden,
      event: 'invoiceType',
      hiddenName: 'invoiceType',
    },
    {
      title: '申请时间',
      type: DateTime,
      hiddenName: 'invoiceApplyTime',
      startTimeName: 'createTimeBegin',
      endTimeName: 'createTimeEnd',
    },
    {
      name: 'accountStatus',
      title: '对账状态',
      type: Hidden,
      event: 'accountStatus',
      hiddenName: 'accountStatus',
    },
    {
      name: 'accountOpenInvoiceStatus',
      title: '供应商开票',
      type: Hidden,
      event: 'accountOpenInvoiceStatus',
      hiddenName: 'accountOpenInvoiceStatus',
    },
    {
      name: 'paymentStatus',
      title: '付款状态',
      type: Hidden,
      event:
        keyName === 'PAYMENTREQUEST' ? 'paymentStatusEnum' : 'paymentStatus',
      hiddenName: 'paymentStatus',
    },
    {
      name: 'paymentNo',
      title: '付款单号',
      type: TEXT,
    },
    {
      title: '提交时间',
      type: DateTime,
      hiddenName: 'paymentRequestTime',
      startTimeName: 'paymentRequestStartTime',
      endTimeName: 'paymentRequestEndTime',
    },
    {
      name: 'orderCount',
      title: '订单数',
      type: TEXT,
    },
    {
      name: 'submitMan',
      title: '提交人',
      type: TEXT,
    },
    {
      name: 'enterPriseName',
      title: '申请人',
      type: TEXT,
    },
    {
      name: 'invoiceApplicationNum',
      title: '开票申请单号',
      type: TEXT,
    },

    {
      name: 'relevancyPlatform',
      title: '关联项目',
      type: TEXT,
    },
    {
      name: 'mainPicture',
      title: '主图',
      type: Hidden,
      event: 'mainPicture',
      hiddenName: 'mainPicture',
    },
    {
      name: 'detailsPicture',
      title: '详情图',
      type: Hidden,
      event: 'detailsPicture',
      hiddenName: 'detailsPicture',
    },
    {
      name: 'extendedAttribute',
      title: '拓展属性',
      type: Hidden,
      event: 'extendedAttribute',
      hiddenName: 'extendedAttribute',
    },
    {
      name: 'srmProductType',
      title: '物料类型',
      type: Hidden,
      event: 'srmProductType',
      hiddenName: 'srmProductType',
    },
    {
      name: 'unitCode',
      title: '单位',
      type: Hidden,
      event: 'unitCode',
      hiddenName: 'unitCode',
    },
    {
      name: 'platformCodes',
      title: '关联项目',
      type: Hidden,
      event: 'platformCodes',
      hiddenName: 'platformCodes',
    },
    {
      name: 'platformCode',
      title: '下单平台',
      type: Hidden,
      event: 'platformCode',
      hiddenName: 'platformCode',
    },
    {
      name: 'srmPlatformCodes',
      title: '关联项目',
      type: Hidden,
      event: 'srmPlatformCodes',
      hiddenName: 'srmPlatformCodes',
    },
    {
      name: 'referenceSupplyPrice',
      title: '参考供货价',
      type: TEXT,
    },
    {
      name: 'filingType',
      title: '报备类型',
      type: Hidden,
      event: 'filingType',
      hiddenName: 'filingType',
    },
    {
      name: 'brandCode',
      title: '品牌编码',
      type: TEXT,
    },
    {
      name: 'brandNameCn',
      title: '品牌中文名',
      type: TEXT,
    },
    {
      name: 'brandNameEn',
      title: '品牌英文名',
      type: TEXT,
    },
    {
      name: 'mpmState',
      title: '审核状态',
      type: Hidden,
      event: 'mpmState',
      hiddenName: 'mpmState',
    },
    {
      name: 'announcementTitle',
      title: '标题',
      type: TEXT,
    },
    {
      name: 'invoiceNum',
      title: '发票号码',
      type: TEXT,
      moduleTitle: {
        MYINVOICE: '发票号',
      },
    },
    {
      name: 'invoiceState',
      title: '发票单状态',
      type: Hidden,
      event: 'invoiceState',
      hiddenName: 'invoiceState',
    },
    {
      name: 'receiveMan',
      title: '收件人',
      type: TEXT,
    },
    {
      name: 'proName',
      title: '物料名称',
      type: TEXT,
    },
    {
      name: 'productCode',
      title: '咸亨商品编码',
      type: TEXT,
    },
    {
      name: 'gwCode',
      title: '国网物料编码',
      type: TEXT,
    },
    {
      name: 'categoryName',
      title: '类目名称',
      type: TEXT,
    },
    {
      name: 'spuModel',
      title: '产品编码',
      type: TEXT,
    },
    {
      name: 'gwProductSerialNumber',
      title: '国网商品编码',
      type: TEXT,
    },
    {
      name: 'orderSource',
      title: '源单类型',
      type: Hidden,
      event: 'orderSource',
      hiddenName: 'orderSource',
    },
    {
      name: 'supplierOpenInvoiceState',
      title: '供应商开票',
      type: Hidden,
      event: 'supplierOpenInvoiceState',
      hiddenName: 'supplierOpenInvoiceState',
    },
    {
      name: 'contractType',
      title: '合同类型',
      type: Hidden,
      event: 'contractType',
      hiddenName: 'contractType',
    },
    {
      title: '创建时间',
      type: DateTime,
      hiddenName: 'contractCreateTime',
      startTimeName: 'createTimeStart',
      endTimeName: 'createTimeFinish',
    },
    {
      name: 'enterpriseCode',
      title: '供应商编码',
      type: TEXT,
    },
    {
      name: 'signatureStatus',
      title: '签章状态',
      type: Hidden,
      event: 'signatureStatus',
      hiddenName: 'signatureStatus',
    },
    {
      name: 'signingType',
      title: '签订方式',
      type: Hidden,
      event: 'signingType',
      hiddenName: 'signingType',
    },
    {
      name: 'landingContractStatus',
      title: '合同状态',
      type: Hidden,
      event: 'landingContractStatus',
      hiddenName: 'landingContractStatus',
    },
    {
      name: 'secondSigningSupplierId',
      title: '对方签约主体',
      type: TEXT,
    },
    {
      title: '提报日期',
      type: DateTime,
      hiddenName: 'submissionTime',
      startTimeName: 'reportStartTime',
      endTimeName: 'reportEndTime',
    },
    {
      name: 'materialCode',
      title: '物料编码',
      type: TEXT,
    },
    {
      name: 'reportType',
      title: '提报类型',
      type: Hidden,
      event: 'reportType',
      hiddenName: 'reportType',
    },
    {
      name: 'projectCode',
      title: '项目名称',
      type: Hidden,
      event: 'platformCodes',
      hiddenName: 'projectCode',
    },
    {
      title: '审核时间',
      type: DateTime,
      hiddenName: 'reportauditTime',
      startTimeName: 'auditStartTime',
      endTimeName: 'auditEndTime',
    },
    {
      name: 'materialCodes',
      title: '商品编码',
      type: TEXT,
    },
    {
      name: 'reportCode',
      title: '审批流编码',
      type: TEXT,
    },
    {
      name: 'returnOrderNo',
      title: '退货单',
      type: TEXT,
    },
    {
      name: 'invoiceNature',
      title: '发票性质',
      type: Hidden,
      event: 'invoiceNature',
      hiddenName: 'invoiceNature',
    },
    {
      name: 'blueInvoiceNum',
      title: '客户订单已开蓝票',
      type: TEXT,
    },
    {
      name: 'returnNo',
      title: '退货单号',
      type: TEXT,
    },
    {
      name: 'customerName',
      title: '客户名称',
      type: TEXT,
    },
    {
      name: 'titleOfTheContract',
      title: '签约抬头',
      type: Hidden,
      event: 'titleOfTheContract',
      hiddenName: 'titleOfTheContract',
    },
    // 询价单相关字段
    {
      name: 'inquiryNo',
      title: '询价单号',
      type: TEXT,
    },
    {
      name: 'groupName',
      title: '询价公司名称',
      type: TEXT,
    },
    {
      title: '询价截止日期',
      type: DateTime,
      hiddenName: 'expireDate',
      startTimeName: 'startExpireDate',
      endTimeName: 'endExpireDate',
    },
    {
      name: 'materialCount',
      title: '物料条数',
      type: SizeQuery,
      sizeQuery: {
        operatorName: 'materialCountOperator',
        numName: 'materialCount',
        ...onlyIntegerCustomProps,
        customProps: {
          selectProps: {
            options: sizeQueryOperatorEnum,
          },
        },
      },
    },
    {
      name: 'status',
      title: '状态',
      type: Hidden,
      event: 'status',
      hiddenName: 'status',
    },
    {
      name: 'itemStatus',
      title: '明细状态',
      type: Hidden,
      event: 'itemStatus',
      hiddenName: 'itemStatus',
    },
    {
      name: 'inquiryTaskNo',
      title: '来源唯一标识码',
      type: TEXT,
    },
    {
      name: 'clientMaterialName',
      title: '客方物资名称',
      type: TEXT,
    },
    {
      name: 'clientMaterialQty',
      title: '数量',
      type: SizeQuery,
      sizeQuery: {
        operatorName: 'clientMaterialQtyOperator',
        numName: 'clientMaterialQty',
        ...onlyIntegerCustomProps,
        customProps: {
          selectProps: {
            options: sizeQueryOperatorEnum,
          },
        },
      },
    },
    {
      name: 'creatorName',
      title: '创建人',
      type: 'TEXT',
    },
    {
      title: '创建日期',
      type: DateTime,
      hiddenName: 'createTimeDate',
      startTimeName: 'startCreatedTime',
      endTimeName: 'endCreatedTime',
    },
    {
      title: '截止日期',
      type: DateTime,
      hiddenName: 'deadlineTime',
      startTimeName: 'startDeadlineTime',
      endTimeName: 'endDeadlineTime',
    },
    {
      title: '物料提交时间',
      type: DateTime,
      hiddenName: 'submitTime',
      startTimeName: 'submitTimeStart',
      endTimeName: 'submitTimeEnd',
    },
    // ========== 1.6.0 项目物料模块字段 ==========
    {
      name: 'productCodes',
      title: '咸亨SKU编码',
      type: TEXT,
    },
    {
      name: 'customerSkuCodes',
      title: '客户SKU编码',
      type: TEXT,
    },
    {
      name: 'customerSpuCodes',
      title: '客户SPU编码',
      type: TEXT,
    },
    {
      name: 'customerMaterialCodes',
      title: '客户物料编码',
      type: TEXT,
    },
    {
      name: 'thirdOnShelf',
      title: '客户平台状态',
      type: Hidden,
      event: 'thirdOnShelf',
      hiddenName: 'thirdOnShelf',
    },
    {
      title: '状态变更时间',
      type: DateTime,
      hiddenName: 'thirdOnShelfChangeTime',
      startTimeName: 'thirdOnShelfStartTime',
      endTimeName: 'thirdOnShelfEndTime',
    },
    {
      name: 'supplierOrderType',
      title: '订单类型',
      type: Hidden,
      event: 'supplierOrderType',
      hiddenName: 'supplierOrderType',
    },
    // 自营协议管理筛选项
    {
      name: 'contractNo',
      title: '协议编号',
      type: TEXT,
    },
    {
      name: 'firstSigningGroupName',
      title: '甲方',
      type: TEXT,
    },
    {
      name: 'agreementSigningType',
      title: '签订方式',
      type: Hidden,
      event: 'agreementSigningType',
      hiddenName: 'agreementSigningType',
    },
    {
      name: 'agreementSignStatus',
      title: '协议签署状态',
      type: Hidden,
      event: 'agreementSignStatus',
      hiddenName: 'agreementSignStatus',
    },
    {
      name: 'agreementStatus',
      title: '协议状态',
      type: Hidden,
      event: 'agreementStatus',
      hiddenName: 'agreementStatus',
    },
    {
      title: '协议有效期',
      type: DateTime,
      hiddenName: 'effective',
      startTimeName: 'effectiveStart',
      endTimeName: 'effectiveEnd',
    },
    {
      name: 'untilContractExpirationDays',
      title: '距离到期天数',
      type: SizeQuery,
      sizeQuery: {
        operatorName: 'untilContractExpirationDaysOperators',
        numName: 'untilContractExpirationDays',
        ...onlyIntegerCustomProps,
        customProps: {
          selectProps: {
            options: sizeQueryOperatorEnum,
          },
        },
      },
    },
    // ========== MPM v5.0.0 项目商品池字段（固定 7 项） ==========
    { name: 'poolProductCode', title: '咸亨编码', type: TEXT },
    { name: 'poolCustomerTitle', title: '客户标题', type: TEXT },
    { name: 'poolBrandName', title: '品牌名称', type: TEXT },
    { name: 'poolCategoryName', title: '类目名称', type: TEXT },
    { name: 'poolRemark', title: '备注', type: TEXT },
    { name: 'poolStandardCode', title: '标准库编码/产品编码', type: TEXT },
    { name: 'poolMaterialCode', title: '物资编码', type: TEXT },
  ]
}
// 方案类型 区分不同模块的方案数据
export const SchemeType = [
  { title: 'SUPPLIERLIST', type: '2' },
  { title: 'INTERNATIONSUPPLIERLIST', type: '6' },
  { title: 'BLACKLIST', type: '7' },
  { title: 'REGISTERWAITAUDIT', type: '15' },
  { title: 'REGISTERAUDITRECORD', type: '4' },
  { title: 'REGISTERSUPPLIERACCOUNT', type: '5' },
  { title: 'MANAGEMYAPPLICATION', type: '8' },
  { title: 'MANAGEWAITAUDIT', type: '9' },
  { title: 'MANAGEAUDITRECORD', type: '10' },
  { title: 'CONTRACTLIST', type: '1' },
  { title: 'METTINGLIST', type: '11' },
  { title: 'ENQUIRYLIST', type: '3' },
  { title: 'ORGMANAGE', type: '14' },
  { title: 'DEPTMANAGE', type: '13' },
  { title: 'USERMANAGE', type: '12' },
  { title: 'BRAND', type: '16' },
  { title: 'AUTHORIZATION', type: '17' },
  { title: 'ACCOUNT', type: '18' },
  { title: 'LAUNCHGOODS', type: '19' },
  { title: 'ORDERASSURANCE', type: '20' },
  { title: 'RETURNMANAGEMENT', type: '21' },
  { title: 'ORDERREGISTRATION', type: '22' },
  { title: 'FINANCIALRECONCILIATION', type: '23' },
  { title: 'ACCOUNTDONEORDER', type: '24' },
  { title: 'SUPPLIERORDERASSURANCE', type: '28' },
  { title: 'SUPPLIERORDERRETURN', type: '29' },
  { title: 'MESSAGECENTER', type: '32' },
  // { title: 'ADDINVOICE', type: '33' },
  // 开票申请
  { title: 'INVOICEAPPLICATION', type: '34' },
  // 可对账订单
  { title: 'RECONCILABLEORDERS', type: '33' },
  { title: 'PAYABLEORDERS', type: '35' },
  { title: 'PAYMENTREQUEST', type: '36' },
  { title: 'LAUNCHBRAND', type: '37' },
  { title: 'XHANNOUNCEMENT', type: '37' },
  { title: 'LANDERINVOICEENTRY', type: '41' },
  { title: 'SUPPLIERINVOICEENTRY', type: '48' },
  { title: 'MYINVOICE', type: '40' },
  { title: 'RELEVANCEBUYER', type: '42' },
  { title: 'INVENTORYMANAGEMENT', type: '46' },
  { title: 'MATERIALPRICEADJUSTMENT', type: '47' },
  // 电商供应商合同
  { title: 'LOCALCONTRACT', type: '38' },
  { title: 'MATERIALSUBMISSION', type: '49' },
  {
    title: 'REDLANDERINVOICEENTRY',
    type: '50',
  },
  {
    title: 'INQUIRYLIST',
    type: '51',
  },
  {
    title: 'MATERIALCODEMODAL',
    type: '56',
  },
  {
    title: 'TODOLIST',
    type: '57',
  },
  {
    title: 'PROJECTMATERIAL',
    type: '58',
  },
  // MPM v5.0.0 项目商品池（页面隐藏方案，编号仅作占位）
  {
    title: 'PROJECTPOOL',
    type: '81',
  },
  // 自营协议管理
  {
    title: 'SELFAGREEMENT',
    type: '59',
  },
] as const
export const SelectCheckBox = [
  'enterpriseNature',
  'platformCodes',
  'srmPlatformCodes',
  'signingType',
  'platformCode',
  'status',
  'supplierOrderType',
]

// 要求时间为毫秒数的参数
export const startTimeStampArr: formName[] = [
  'orderTimeStart',
  'dispatchTimeStart',
  'reportStartTime',
  'auditStartTime',
  'returnStartTime',
  'startExpireDate',
  'inquiryStartDate',
  'quotationTimeStart',
  'startCreatedTime',
  'startDeadlineTime',
  'inquiryDateStart',
  'thirdOnShelfStartTime',
  'effectiveStart',
]
export const endTimeStampArr: formName[] = [
  'orderTimeEnd',
  'dispatchTimeEnd',
  'reportEndTime',
  'auditEndTime',
  'returnEndTime',
  'endExpireDate',
  'inquiryEndDate',
  'quotationTimeEnd',
  'endCreatedTime',
  'endDeadlineTime',
  'inquiryDateEnd',
  'thirdOnShelfEndTime',
  'effectiveEnd',
]

export type ScreenKey = (typeof SchemeType)[number]['title']
// export type ScreenKey =
//   // 国内供应商列表
//   | 'SUPPLIERLIST'
//   // 国际供应商列表
//   | 'INTERNATIONSUPPLIERLIST'
//   // 黑名单
//   | 'BLACKLIST'
//   // 前台-待审核
//   | 'REGISTERWAITAUDIT'
//   // 前台-审核记录
//   | 'REGISTERAUDITRECORD'
//   // 前台-供应商账号
//   | 'REGISTERSUPPLIERACCOUNT'
//   // 后台-我的申请
//   | 'MANAGEMYAPPLICATION'
//   // 后台-待我审核
//   | 'MANAGEWAITAUDIT'
//   // 后台-审核记录
//   | 'MANAGEAUDITRECORD'
//   // 合同列表
//   | 'CONTRACTLIST'
//   // 会议列表
//   | 'METTINGLIST'
//   // 记录列表
//   | 'ENQUIRYLIST'
//   // 组织管理
//   | 'ORGMANAGE'
//   // 部门管理
//   | 'DEPTMANAGE'
//   // 用户管理
//   | 'USERMANAGE'
//   // 品牌
//   | 'BRAND'
//   // 品牌授权
//   | 'AUTHORIZATION'
//   //
//   | 'ACCOUNT'
//   | 'LAUNCHGOODS'
//   | 'ORDERASSURANCE'
//   | 'RETURNMANAGEMENT'
//   | 'ORDERREGISTRATION' // 报备单
//   | 'FINANCIALRECONCILIATION' // 对账单
//   | 'ACCOUNTDONEORDER' // 对账单 已验收订单
//   | 'SUPPLIERORDERASSURANCE' // 供应商订单
//   | 'SUPPLIERORDERRETURN' // 供应商退货
//   | 'MESSAGECENTER' // 消息中心
//   // 这个取消，和开票申请用同一份
//   // | 'ADDINVOICE' //申请开票
//   // 开票申请
//   | 'INVOICEAPPLICATION'
//   | 'RECONCILABLEORDERS'
//   // 可付款订单列表
//   | 'PAYABLEORDERS'
//   // 付款申请列表
//   | 'PAYMENTREQUEST'
//   | 'LAUNCHBRAND'
//   | 'XHANNOUNCEMENT'
//   | 'LANDERINVOICEENTRY'
//   | 'SUPPLIERINVOICEENTRY'
//   | 'MYINVOICE'
//   | 'RELEVANCEBUYER'
//   | 'INVENTORYMANAGEMENT'
//   | 'MATERIALPRICEADJUSTMENT' // 国网物料调价
//   | 'LOCALCONTRACT' // 合同管理
//   | 'MATERIALSUBMISSION' // 项目物料提报管理
//   // 红票录入
//   | 'REDLANDERINVOICEENTRY'
import { sizeQueryOperatorEnum } from '@/global/enum'
import { onlyIntegerCustomProps } from './constraint'

export const SizeQueryList = (keyName: string) => {
  return FormItemData(keyName).filter((item) => item.type === 'SizeQuery')
}

// 接口接受参数
export type formName =
  | 'schemeId' // 方案id
  // MPM v5.0.0 项目商品池（固定 7 项业务筛选）
  | 'poolProductCode' // 咸亨编码
  | 'poolCustomerTitle' // 客户标题
  | 'poolBrandName' // 品牌名称
  | 'poolCategoryName' // 类目名称
  | 'poolRemark' // 备注
  | 'poolStandardCode' // 标准库编码/产品编码
  | 'poolMaterialCode' // 物资编码
  // 3.0.0 模块筛选
  | 'contractStartDate'
  | 'contractEndDate'
  | 'enterpriseName'
  | 'contractNum'
  | 'isFile'
  | 'contractStatus'
  | 'enterpriseLevel'
  | 'uploadStartDate'
  | 'uploadEndDate'
  | 'productName'
  | 'model'
  | 'offererName'
  | 'offererPhone'
  | 'inquiryStartDate'
  | 'inquiryEndDate'
  | 'inquirer'
  | 'brands'
  | 'mettingName'
  | 'personnel'
  | 'depart'
  | 'deptCode'
  | 'name'
  | 'erpOrgCode'
  | 'startDate'
  | 'endDate'
  | 'purchaserName'
  | 'purchaser'
  | 'level'
  | 'contacts'
  | 'mobile'
  | 'industry'
  | 'enterpriseNature'
  | 'erpState'
  | 'erpCode'
  | 'state'
  | 'country'
  | 'manageBrand'
  | 'uscc'
  | 'corporate'
  | 'applyStartDate'
  | 'applyEndDate'
  | 'applyType'
  | 'checkMan'
  | 'auditStartDate'
  | 'auditEndDate'
  | 'checkState'
  | 'realName'
  | 'mail'
  | 'brand'
  | 'code'
  | 'brandName'
  | 'isPermission'
  | 'manageType'
  | 'authorizationType'
  | 'fileName'
  | 'supplierName'
  | 'batchNumber'
  | 'ossConn'
  | 'tempCode'
  // 4.0.0新增
  // 订单履约模块
  | 'address' // 收货地址
  | 'consignee' // 收件人
  | 'customer' // 客户名称
  //   | 'endDate'
  | 'invoicingState' // 开票状态
  //   | 'mobile'
  | 'orderNo' // 客户订单号
  | 'orderState' // 订单状态
  | 'platform' // 下单平台
  // 5.0.0 电商供应商订单
  | 'customerPayback' // 客户回款
  | 'signVoucher' // 签收凭证
  | 'orderRemark'
  // 7.8.0
  | 'overdueType' // 订单超期
  //   | 'startDate'
  //   | 'supplierId'
  // 退货模块
  | 'orderReturnNo'
  | 'returnCount'
  | 'returnPrice'
  | 'returnApplyDate'
  // | 'returnState'
  | 'returnType'
  | 'returnApplyStartDate'
  | 'returnApplyEndDate'
  // 报备单管理
  | 'filingArriveStartTime'
  | 'filingArriveEndTime'
  | 'filingStartTime'
  | 'filingEndTime'
  | 'filingNo'
  | 'filingOrderStartTime'
  | 'filingOrderEndTime'
  | 'fillingState'
  | 'num'
  | 'platform'
  | 'price'
  // 对账单
  | 'accountStartTime'
  | 'accountEndTime'
  | 'accountNo'
  | 'accountState'
  | 'accountPrice'
  | 'orderStartTime'
  | 'orderEndTime'
  | 'settlePrice'
  // 供应商订单
  | 'supplierOrderCode'
  | 'supplierOrderEndTime'
  | 'supplierOrderGroupName'
  | 'supplierOrderReceiveMan'
  | 'supplierOrderStartTime'
  | 'supplierDirectShipment'
  // 退货
  | 'supplierOrderReturnCode'
  | 'supplierOrderReturnGroupName'
  | 'upplierOrderReturnReceiveMan'
  | 'supplierOrderReturnNumber'
  | 'supplierOrderReturnReceiveMan'
  | 'supplierOrderReturnStartTime'
  | 'supplierOrderReturnEndTime'
  | 'supplierOrderDirectShipment'
  // 消息中心
  | 'content'
  | 'messageType'
  // 5.0.0开票
  | 'logisticsNum'
  | 'title' // 发票抬头
  | 'invoiceType' // 发票类型
  // 开票-申请时间
  | 'createTimeBegin'
  | 'createTimeEnd'
  | 'accountStatus' // 对账状态
  | 'accountOpenInvoiceStatus' // 电商供应商订单-供应商开票状态
  | 'paymentStatus' // 付款状态
  | 'paymentNo' // 付款单号
  // 付款单
  | 'orderTimeStart'
  | 'orderTimeEnd'
  | 'paymentRequestEndTime'
  | 'paymentRequestStartTime'
  // 订单数
  | 'orderCount'
  | 'submitMan'
  | 'enterPriseName'
  | 'invoiceApplicationNum'
  // 待提交物料
  | 'mainPicture'
  | 'detailsPicture'
  | 'extendedAttribute'
  | 'relevancyPlatform'
  | 'srmProductType' // 物料类型
  | 'unitCode'
  // 关联项目
  | 'platformCodes'
  | 'srmPlatformCodes'
  | 'referenceSupplyPrice'
  // 5.6.0
  | 'filingType' // 报备单类型
  // 5.7.2 我的品牌
  | 'brandCode'
  | 'brandNameCn'
  | 'brandNameEn'
  | 'mpmState'
  | 'announcementTitle'
  | 'invoiceNum'
  | 'invoiceState'
  | 'receiveMan'
  | 'proName'
  | 'productCode'
  | 'gwCode'
  | 'spuModel'
  | 'gwProductSerialNumber'
  | 'categoryName'
  | 'orderSource'
  | 'supplierOpenInvoiceState' // 供应商订单-供应商开票状态
  | 'contractType'
  | 'createTimeStart'
  | 'createTimeFinish'
  | 'enterpriseCode'
  | 'signatureStatus'
  | 'signingType'
  | 'landingContractStatus'
  | 'secondSigningSupplierId'
  // 我的物料
  | 'firstPassStart' // 咸亨上架时间
  | 'firstPassEnd'
  | 'startWriteOffTime'
  | 'endWriteOffTime'
  | 'paymentTypeName'
  | 'manuCode'
  | 'dispatchTimeStart'
  | 'dispatchTimeEnd'
  | 'reportStartTime'
  | 'reportEndTime'
  | 'materialCode'
  | 'reportType'
  | 'projectCode'
  | 'auditStartTime'
  | 'auditEndTime'
  | 'materialCodes'
  | 'reportCode'
  | 'invoiceNature'
  | 'returnOrderNo'
  | 'blueInvoiceNum'
  | 'returnNo'
  | 'customerName'
  | 'platformCode'
  | 'titleOfTheContract'
  | 'returnTime'
  | 'returnStartTime'
  | 'returnEndTime'
  // 询价单
  | 'inquiryNo'
  | 'groupName'
  | 'startExpireDate'
  | 'endExpireDate'
  | 'materialCount'
  | 'status'
  | 'itemStatus'
  | 'inquiryTaskNo'
  | 'clientMaterialName'
  | 'clientMaterialQty'
  | 'clientMaterialQtyOperator'
  | 'quotationTimeStart'
  | 'quotationTimeEnd'
  | 'creatorName'
  | 'startCreatedTime'
  | 'endCreatedTime'
  | 'startDeadlineTime'
  | 'endDeadlineTime'
  | 'submitTimeStart'
  | 'submitTimeEnd'
  | 'inquiryDateStart'
  | 'inquiryDateEnd'
  | 'inquiryDate'
  | 'submitTimeStart'
  | 'submitTimeEnd'
  // 1.6.0 项目物料模块（与 projectMaterial 查询接口字段名一致）
  | 'productCodes' // 咸亨SKU编码
  | 'customerSkuCodes' // 客户SKU编码
  | 'customerSpuCodes' // 客户SPU编码
  | 'customerMaterialCodes' // 客户物料编码
  | 'thirdOnShelf' // 客户平台状态
  | 'thirdOnShelfStartTime' // 状态变更开始时间
  | 'thirdOnShelfEndTime' // 状态变更结束时间
  | 'supplierOrderType'
  // 自营协议管理
  | 'contractNo'
  | 'firstSigningGroupName'
  | 'agreementSigningType'
  | 'agreementSignStatus'
  | 'agreementStatus'
  | 'effective'
  | 'effectiveStart'
  | 'effectiveEnd'
  | 'untilContractExpirationDays'
  | 'untilContractExpirationDaysOperators'

// 获取筛选条件data唯一key
export type EventNameType =
  | 'isFile'
  | 'contractStatus'
  | 'enterpriseLevel'
  | 'level'
  | 'industry'
  | 'enterpriseNature'
  | 'erpState'
  | 'state'
  | 'applyType'
  | 'checkState'
  | 'manageType'
  | 'isPermission'
  | 'authorizationType'
  | 'ossConn'
  // 4.0.0
  | 'invoicingState' // 订单履约 开票状态 下拉框
  | 'orderState' // 订单状态
  | 'platform'

  // 5.0.0 电商供应商订单
  | 'customerPayback' // 客户回款
  | 'signVoucher' // 签收凭证
  // 7.8.0
  | 'overdueType' // 订单超期
  // 退货单
  | 'returnType'
  | 'fillingState'
  | 'accountState' // 对账单状态
  | 'supplierDirectShipment'
  | 'messageType'
  | 'invoiceType'
  | 'accountStatus' // 对账状态
  | 'accountOpenInvoiceStatus' // 供应商开票状态
  | 'paymentStatus' // 付款状态
  | 'mainPicture' // 主图
  | 'detailsPicture' // 详情图
  | 'extendedAttribute' // 拓展属性
  | 'srmProductType' // 物料类型
  | 'unitCode'
  | 'platformCodes'
  | 'srmPlatformCodes'
  | 'referenceSupplyPrice'
  // 5.6.0
  | 'filingType' // 报备单类型
  | 'manageType'
  | 'mpmState'
  | 'announcementTitle'
  | 'invoiceState'
  | 'receiveMan'
  | 'orderSource'
  | 'supplierOpenInvoiceState'
  | 'contractType'
  | 'createTimeStart'
  | 'createTimeFinish'
  | 'enterpriseCode'
  | 'signatureStatus'
  | 'signingType'
  | 'landingContractStatus'
  | 'secondSigningSupplierId'
  | 'manuCode'
  | 'proName'
  | 'paymentStatusEnum'
  | 'reportType'
  | 'invoiceNature'
  | 'platformCode'
  | 'titleOfTheContract'
  | 'status' // 询价单状态
  | 'materialCountLevel' // 物料条数运算符
  | 'itemStatus' // 询价明细状态
  // 1.6.0 项目物料
  | 'thirdOnShelf' // 客户平台状态（接口 thirdOnShelf）
  | 'pmAuditStatus' // 项目物料-审核状态
  | 'pmReportType' // 项目物料-提报类型
  | 'supplierOrderType'
  // 自营协议管理
  | 'agreementSigningType'
  | 'agreementSignStatus'
  | 'agreementStatus'

export const TEXT = 'TEXT' // 输入型
export const Hidden = 'Hidden' // 选择型
export const DateTime = 'DateTime' // 时间范围型
export const SizeQuery = 'SizeQuery'
export type ItemParam = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x in EventNameType]?: any
} & {
  title: string // 名称
  name?: formName // name
  type: typeof TEXT | typeof DateTime | typeof Hidden | typeof SizeQuery // 类型
  event?: EventNameType // 事件对象
  hiddenName?: string // 显示的name字段
  startTimeName?: formName // 开始 日期范围标志 name
  endTimeName?: formName // 结束 日期范围标志 name
  range?: {
    operatorName: string // 运算符字段名
    selectEvent: string // 选择事件名
    contrastName: string // 对比值字段名
  } // 数字范围配置
  moduleTitle?: {
    [x in ScreenKey]?: string
  } // 根据模块区分要展示的名称
}
export const FormItemData = (keyName?: string) => {
  return [
    {
      title: '合同时间',
      type: DateTime,
      hiddenName: 'contractTime',
      startTimeName: 'contractStartDate',
      endTimeName: 'contractEndDate',
    },
    {
      name: 'enterpriseName',
      title: '供应商名称',
      type: TEXT,
    },
    {
      name: 'contractNum',
      title: '合同号',
      type: TEXT,
    },
    {
      name: 'enterpriseLevel',
      title: '供应商等级',
      type: Hidden,
      event: 'enterpriseLevel',
      hiddenName: 'enterpriseLevel',
    },
    {
      name: 'isFile',
      title: '附件状态',
      type: Hidden,
      event: 'isFile',
      hiddenName: 'isFile',
    },
    {
      name: 'contractStatus',
      title: '合同状态',
      type: Hidden,
      event: 'contractStatus',
      hiddenName: 'contractStatus',
    },
    {
      title: '上传时间',
      type: DateTime,
      hiddenName: 'time',
      startTimeName: 'uploadStartDate',
      endTimeName: 'uploadEndDate',
    },
    {
      name: 'productName',
      title: '商品名称',
      type: TEXT,
      moduleTitle: {
        PROJECTMATERIAL: '咸亨物料名称',
      },
    },
    {
      name: 'offererName',
      title: '报价人',
      type: TEXT,
    },
    {
      name: 'offererPhone',
      title: '报价人手机',
      type: TEXT,
    },
    {
      title: '询价时间',
      type: DateTime,
      hiddenName: 'enquiryTime',
      startTimeName: 'inquiryStartDate',
      endTimeName: 'inquiryEndDate',
    },
    {
      title: '询价日期',
      type: DateTime,
      hiddenName: 'quotationTime',
      startTimeName: 'quotationTimeStart',
      endTimeName: 'quotationTimeEnd',
    },
    {
      title: '询价日期',
      type: DateTime,
      hiddenName: 'inquiryDate',
      startTimeName: 'inquiryDateStart',
      endTimeName: 'inquiryDateEnd',
    },
    {
      name: 'inquirer',
      title: '询价人',
      type: TEXT,
    },
    {
      name: 'brands',
      title: '维护品牌',
      type: TEXT,
    },
    {
      name: 'mettingName',
      title: '会议名称',
      type: TEXT,
    },
    {
      name: 'personnel',
      title: '参会人员',
      type: TEXT,
    },
    {
      name: 'depart',
      title: 'SRM部门名称',
      type: TEXT,
    },
    {
      name: 'deptCode',
      title: 'SRM部门编码',
      type: TEXT,
    },
    {
      name: 'erpOrgCode',
      title: 'ERP组织编码',
      type: TEXT,
    },
    {
      name: 'realName',
      title: '姓名',
      type: TEXT,
    },
    {
      title: '下单时间',
      type: DateTime,
      hiddenName: 'createTime',
      startTimeName: 'startDate',
      endTimeName: 'endDate',
    },
    {
      name: 'purchaserName',
      title: '负责采购',
      type: TEXT,
      moduleTitle: {
        INQUIRYLIST: '采购员',
      },
    },
    {
      name: 'purchaser',
      title: '采购员',
      type: TEXT,
    },
    {
      name: 'erpCode',
      title: 'ERP编码',
      type: TEXT,
    },

    {
      name: 'contacts',
      title: '联系人',
      type: TEXT,
    },
    {
      name: 'mobile',
      title: '联系方式',
      type: TEXT,
    },
    {
      name: 'industry',
      title: '行业',
      type: Hidden,
      event: 'industry',
      hiddenName: 'industry',
    },
    {
      name: 'enterpriseNature',
      title: '供应商性质',
      type: Hidden,
      event: 'enterpriseNature',
      hiddenName: 'enterpriseNature',
    },
    {
      name: 'erpState',
      title: '同步ERP状态',
      type: Hidden,
      event: 'erpState',
      hiddenName: 'erpState',
    },
    {
      name: 'state',
      title: '前台',
      type: Hidden,
      event: 'state',
      hiddenName: 'state',
    },
    {
      name: 'country',
      title: '国家',
      type: TEXT,
    },
    {
      name: 'uscc',
      title: '统一社会信用代码',
      type: TEXT,
    },
    {
      name: 'manageBrand',
      title: '经营品牌',
      type: TEXT,
    },
    {
      name: 'corporate',
      title: '法人',
      type: TEXT,
    },
    {
      title: '申请时间',
      type: DateTime,
      hiddenName: 'applyTime',
      startTimeName: 'applyStartDate',
      endTimeName: 'applyEndDate',
    },
    {
      title: '审核时间',
      type: DateTime,
      hiddenName: 'auditTime',
      startTimeName: 'auditStartDate',
      endTimeName: 'auditEndDate',
    },
    {
      name: 'applyType',
      title: '申请类型',
      type: Hidden,
      event: 'applyType',
      hiddenName: 'applyType',
    },
    {
      name: 'checkState',
      title: '审核状态',
      type: Hidden,
      event: 'checkState',
      hiddenName: 'checkState',
    },
    {
      name: 'mail',
      title: '邮箱',
      type: TEXT,
    },
    {
      name: 'brand',
      title: '品牌',
      type: TEXT,
    },
    {
      name: 'brandName',
      title: '品牌名',
      type: TEXT,
    },
    {
      name: 'isPermission',
      title: '授权书',
      type: Hidden,
      event: 'isPermission',
      hiddenName: 'isPermission',
    },
    {
      name: 'manageType',
      title: '经营形式',
      type: Hidden,
      event: 'manageType',
      hiddenName: 'manageType',
    },
    {
      name: 'authorizationType',
      title: '授权类型',
      type: Hidden,
      event: 'authorizationType',
      hiddenName: 'authorizationType',
    },
    {
      name: 'fileName',
      title: '文件名',
      type: TEXT,
    },
    {
      name: 'code',
      title: '编码',
      type: TEXT,
    },
    {
      name: 'model',
      title: '规格型号',
      type: TEXT,
    },
    {
      name: 'manuCode',
      title: '规格型号',
      type: TEXT,
    },
    {
      name: 'name',
      title: '商品名称',
      type: TEXT,
      moduleTitle: {
        MATERIALPRICEADJUSTMENT: '物料名称',
        MATERIALCODEMODAL: '名称',
      },
    },
    {
      name: 'checkMan',
      title: '审核人',
      type: TEXT,
    },
    {
      name: 'ossConn',
      title: 'OSS上传',
      type: Hidden,
      event: 'ossConn',
      hiddenName: 'ossConn',
    },
    {
      name: 'supplierName',
      title: '供应商名称',
      type: TEXT,
    },
    {
      name: 'batchNumber',
      title: '批号',
      type: TEXT,
    },
    {
      name: 'tempCode',
      title: '编码',
      type: TEXT,
    },
    //   4.0.0订单履约模块
    {
      name: 'address',
      title: '收货地址',
      type: TEXT,
    },

    {
      name: 'consignee',
      title: '收件人',
      type: TEXT,
    },
    {
      name: 'customer',
      title: '客户名称',
      type: TEXT,
    },
    {
      name: 'invoicingState',
      title: '客户开票',
      type: Hidden,
      event: 'invoicingState',
      hiddenName: 'invoicingState',
    },
    {
      name: 'orderNo',
      title: '客户订单号',
      type: TEXT,
    },
    {
      name: 'orderState',
      title: '订单状态',
      type: Hidden,
      event: 'orderState',
      hiddenName: 'orderState',
    },
    {
      name: 'orderRemark',
      title: '客户备注',
      type: TEXT,
    },
    {
      name: 'overdueType',
      title: '订单超期',
      type: Hidden,
      event: 'overdueType',
      hiddenName: 'overdueType',
    },
    {
      name: 'platform',
      title: '项目名称',
      type: Hidden,
      event: 'platform',
      hiddenName: 'platform',
      moduleTitle: {
        MYINVOICE: '下单平台',
      },
    },
    {
      name: 'orderReturnNo',
      title: '退货订单号',
      type: TEXT,
    },
    {
      name: 'returnCount',
      title: '退货数量',
      type: TEXT,
    },
    {
      name: 'returnPrice',
      title: '退货金额',
      type: TEXT,
    },
    {
      name: 'returnType',
      title: '申请单类型',
      type: Hidden,
      event: 'returnType',
      hiddenName: 'returnType',
    },
    {
      title: '申请时间',
      type: DateTime,
      hiddenName: 'returnApplyDate',
      startTimeName: 'returnApplyStartDate',
      endTimeName: 'returnApplyEndDate',
    },
    {
      title: '到期日',
      type: DateTime,
      hiddenName: 'filingArriveTime',
      startTimeName: 'filingArriveStartTime',
      endTimeName: 'filingArriveEndTime',
    },
    {
      title: '报备时间',
      type: DateTime,
      hiddenName: 'filingTime',
      startTimeName: 'filingStartTime',
      endTimeName: 'filingEndTime',
    },
    {
      title: '咸亨上架时间',
      type: DateTime,
      hiddenName: 'firstPassTime',
      startTimeName: 'firstPassStart',
      endTimeName: 'firstPassEnd',
    },
    {
      title: '预计点单日',
      type: DateTime,
      hiddenName: 'filingOrderTime',
      startTimeName: 'filingOrderStartTime',
      endTimeName: 'filingOrderEndTime',
    },
    {
      name: 'filingNo',
      title: '报备单号',
      type: TEXT,
    },
    {
      name: 'fillingState',
      title: '报备单状态',
      type: Hidden,
      event: 'fillingState',
      hiddenName: 'fillingState',
    },
    {
      name: 'num',
      title: '数量',
      type: TEXT,
    },
    {
      name: 'price',
      title: '金额',
      type: TEXT,
    },
    {
      name: 'accountState',
      title: '对账单状态',
      type: Hidden,
      event: 'accountState',
      hiddenName: 'accountState',
    },
    {
      name: 'accountNo',
      title: '对账单号',
      type: TEXT,
    },
    {
      title: '申请时间',
      type: DateTime,
      hiddenName: 'accountApplyTime',
      startTimeName: 'accountStartTime',
      endTimeName: 'accountEndTime',
    },
    {
      name: 'accountPrice',
      title: '已回金额',
      type: TEXT,
    },
    {
      title: '下单时间',
      type: DateTime,
      hiddenName: 'orderDoneTime',
      startTimeName: 'orderStartTime',
      endTimeName: 'orderEndTime',
    },
    {
      title: '下单时间',
      type: DateTime,
      hiddenName: 'orderDoneTime2',
      startTimeName: 'orderTimeStart',
      endTimeName: 'orderTimeEnd',
    },
    {
      title: '派单时间',
      type: DateTime,
      hiddenName: 'dispatchTime',
      startTimeName: 'dispatchTimeStart',
      endTimeName: 'dispatchTimeEnd',
    },
    {
      name: 'settlePrice',
      title: '最终结算金额',
      type: TEXT,
    },
    {
      name: 'supplierOrderCode',
      title: '采购订单号',
      type: TEXT,
    },
    {
      title: '创建时间',
      type: DateTime,
      hiddenName: 'supplierOrderTime',
      startTimeName: 'supplierOrderStartTime',
      endTimeName: 'supplierOrderEndTime',
    },
    {
      name: 'supplierOrderGroupName',
      title: '采购组织',
      type: TEXT,
    },
    {
      name: 'supplierOrderReceiveMan',
      title: '收件人',
      type: TEXT,
    },
    {
      name: 'supplierDirectShipment',
      title: '是否厂直发',
      type: Hidden,
      event: 'supplierDirectShipment',
      hiddenName: 'supplierDirectShipment',
    },
    {
      name: 'supplierOrderReturnCode',
      title: '采购订单号',
      type: TEXT,
    },
    {
      name: 'paymentTypeName',
      title: '最新回款方式',
      type: TEXT,
    },
    {
      name: 'supplierOrderReturnGroupName',
      title: '采购组织',
      type: TEXT,
    },
    {
      name: 'supplierOrderReturnReceiveMan',
      title: '采购员',
      type: TEXT,
    },
    {
      name: 'supplierOrderReturnNumber',
      title: '单号',
      type: TEXT,
    },
    {
      name: 'supplierOrderDirectShipment',
      title: '是否厂直发',
      type: Hidden,
      event: 'supplierDirectShipment',
      hiddenName: 'supplierOrderDirectShipment',
    },
    {
      title: '创建时间',
      type: DateTime,
      hiddenName: 'supplierOrderReturnTime',
      startTimeName: 'supplierOrderReturnStartTime',
      endTimeName: 'supplierOrderReturnEndTime',
    },
    {
      title: '退货时间',
      type: DateTime,
      hiddenName: 'returnTime',
      startTimeName: 'returnStartTime',
      endTimeName: 'returnEndTime',
    },
    {
      title: '最新核销时间',
      type: DateTime,
      hiddenName: 'writeOffTime',
      startTimeName: 'startWriteOffTime',
      endTimeName: 'endWriteOffTime',
    },
    {
      name: 'content',
      title: '消息内容',
      type: TEXT,
    },
    {
      name: 'messageType',
      title: '消息类型',
      type: Hidden,
      event: 'messageType',
      hiddenName: 'messageType',
    },
    {
      name: 'signVoucher',
      title: '签收凭证',
      type: Hidden,
      event: 'signVoucher',
      hiddenName: 'signVoucher',
    },
    {
      name: 'customerPayback',
      title: '客户回款',
      type: Hidden,
      event: 'customerPayback',
      hiddenName: 'customerPayback',
    },
    {
      name: 'logisticsNum',
      title: '物流单号',
      type: 'TEXT',
    },
    {
      name: 'title',
      title: '发票抬头',
      type: 'TEXT',
      moduleTitle: {
        TODOLIST: '待办标题',
      },
    },
    {
      name: 'invoiceType',
      title: '发票类型',
      type: Hidden,
      event: 'invoiceType',
      hiddenName: 'invoiceType',
    },
    {
      title: '申请时间',
      type: DateTime,
      hiddenName: 'invoiceApplyTime',
      startTimeName: 'createTimeBegin',
      endTimeName: 'createTimeEnd',
    },
    {
      name: 'accountStatus',
      title: '对账状态',
      type: Hidden,
      event: 'accountStatus',
      hiddenName: 'accountStatus',
    },
    {
      name: 'accountOpenInvoiceStatus',
      title: '供应商开票',
      type: Hidden,
      event: 'accountOpenInvoiceStatus',
      hiddenName: 'accountOpenInvoiceStatus',
    },
    {
      name: 'paymentStatus',
      title: '付款状态',
      type: Hidden,
      event:
        keyName === 'PAYMENTREQUEST' ? 'paymentStatusEnum' : 'paymentStatus',
      hiddenName: 'paymentStatus',
    },
    {
      name: 'paymentNo',
      title: '付款单号',
      type: TEXT,
    },
    {
      title: '提交时间',
      type: DateTime,
      hiddenName: 'paymentRequestTime',
      startTimeName: 'paymentRequestStartTime',
      endTimeName: 'paymentRequestEndTime',
    },
    {
      name: 'orderCount',
      title: '订单数',
      type: TEXT,
    },
    {
      name: 'submitMan',
      title: '提交人',
      type: TEXT,
    },
    {
      name: 'enterPriseName',
      title: '申请人',
      type: TEXT,
    },
    {
      name: 'invoiceApplicationNum',
      title: '开票申请单号',
      type: TEXT,
    },

    {
      name: 'relevancyPlatform',
      title: '关联项目',
      type: TEXT,
    },
    {
      name: 'mainPicture',
      title: '主图',
      type: Hidden,
      event: 'mainPicture',
      hiddenName: 'mainPicture',
    },
    {
      name: 'detailsPicture',
      title: '详情图',
      type: Hidden,
      event: 'detailsPicture',
      hiddenName: 'detailsPicture',
    },
    {
      name: 'extendedAttribute',
      title: '拓展属性',
      type: Hidden,
      event: 'extendedAttribute',
      hiddenName: 'extendedAttribute',
    },
    {
      name: 'srmProductType',
      title: '物料类型',
      type: Hidden,
      event: 'srmProductType',
      hiddenName: 'srmProductType',
    },
    {
      name: 'unitCode',
      title: '单位',
      type: Hidden,
      event: 'unitCode',
      hiddenName: 'unitCode',
    },
    {
      name: 'platformCodes',
      title: '关联项目',
      type: Hidden,
      event: 'platformCodes',
      hiddenName: 'platformCodes',
    },
    {
      name: 'platformCode',
      title: '下单平台',
      type: Hidden,
      event: 'platformCode',
      hiddenName: 'platformCode',
    },
    {
      name: 'srmPlatformCodes',
      title: '关联项目',
      type: Hidden,
      event: 'srmPlatformCodes',
      hiddenName: 'srmPlatformCodes',
    },
    {
      name: 'referenceSupplyPrice',
      title: '参考供货价',
      type: TEXT,
    },
    {
      name: 'filingType',
      title: '报备类型',
      type: Hidden,
      event: 'filingType',
      hiddenName: 'filingType',
    },
    {
      name: 'brandCode',
      title: '品牌编码',
      type: TEXT,
    },
    {
      name: 'brandNameCn',
      title: '品牌中文名',
      type: TEXT,
    },
    {
      name: 'brandNameEn',
      title: '品牌英文名',
      type: TEXT,
    },
    {
      name: 'mpmState',
      title: '审核状态',
      type: Hidden,
      event: 'mpmState',
      hiddenName: 'mpmState',
    },
    {
      name: 'announcementTitle',
      title: '标题',
      type: TEXT,
    },
    {
      name: 'invoiceNum',
      title: '发票号码',
      type: TEXT,
      moduleTitle: {
        MYINVOICE: '发票号',
      },
    },
    {
      name: 'invoiceState',
      title: '发票单状态',
      type: Hidden,
      event: 'invoiceState',
      hiddenName: 'invoiceState',
    },
    {
      name: 'receiveMan',
      title: '收件人',
      type: TEXT,
    },
    {
      name: 'proName',
      title: '物料名称',
      type: TEXT,
    },
    {
      name: 'productCode',
      title: '咸亨商品编码',
      type: TEXT,
    },
    {
      name: 'gwCode',
      title: '国网物料编码',
      type: TEXT,
    },
    {
      name: 'categoryName',
      title: '类目名称',
      type: TEXT,
    },
    {
      name: 'spuModel',
      title: '产品编码',
      type: TEXT,
    },
    {
      name: 'gwProductSerialNumber',
      title: '国网商品编码',
      type: TEXT,
    },
    {
      name: 'orderSource',
      title: '源单类型',
      type: Hidden,
      event: 'orderSource',
      hiddenName: 'orderSource',
    },
    {
      name: 'supplierOpenInvoiceState',
      title: '供应商开票',
      type: Hidden,
      event: 'supplierOpenInvoiceState',
      hiddenName: 'supplierOpenInvoiceState',
    },
    {
      name: 'contractType',
      title: '合同类型',
      type: Hidden,
      event: 'contractType',
      hiddenName: 'contractType',
    },
    {
      title: '创建时间',
      type: DateTime,
      hiddenName: 'contractCreateTime',
      startTimeName: 'createTimeStart',
      endTimeName: 'createTimeFinish',
    },
    {
      name: 'enterpriseCode',
      title: '供应商编码',
      type: TEXT,
    },
    {
      name: 'signatureStatus',
      title: '签章状态',
      type: Hidden,
      event: 'signatureStatus',
      hiddenName: 'signatureStatus',
    },
    {
      name: 'signingType',
      title: '签订方式',
      type: Hidden,
      event: 'signingType',
      hiddenName: 'signingType',
    },
    {
      name: 'landingContractStatus',
      title: '合同状态',
      type: Hidden,
      event: 'landingContractStatus',
      hiddenName: 'landingContractStatus',
    },
    {
      name: 'secondSigningSupplierId',
      title: '对方签约主体',
      type: TEXT,
    },
    {
      title: '提报日期',
      type: DateTime,
      hiddenName: 'submissionTime',
      startTimeName: 'reportStartTime',
      endTimeName: 'reportEndTime',
    },
    {
      name: 'materialCode',
      title: '物料编码',
      type: TEXT,
    },
    {
      name: 'reportType',
      title: '提报类型',
      type: Hidden,
      event: 'reportType',
      hiddenName: 'reportType',
    },
    {
      name: 'projectCode',
      title: '项目名称',
      type: Hidden,
      event: 'platformCodes',
      hiddenName: 'projectCode',
    },
    {
      title: '审核时间',
      type: DateTime,
      hiddenName: 'reportauditTime',
      startTimeName: 'auditStartTime',
      endTimeName: 'auditEndTime',
    },
    {
      name: 'materialCodes',
      title: '商品编码',
      type: TEXT,
    },
    {
      name: 'reportCode',
      title: '审批流编码',
      type: TEXT,
    },
    {
      name: 'returnOrderNo',
      title: '退货单',
      type: TEXT,
    },
    {
      name: 'invoiceNature',
      title: '发票性质',
      type: Hidden,
      event: 'invoiceNature',
      hiddenName: 'invoiceNature',
    },
    {
      name: 'blueInvoiceNum',
      title: '客户订单已开蓝票',
      type: TEXT,
    },
    {
      name: 'returnNo',
      title: '退货单号',
      type: TEXT,
    },
    {
      name: 'customerName',
      title: '客户名称',
      type: TEXT,
    },
    {
      name: 'titleOfTheContract',
      title: '签约抬头',
      type: Hidden,
      event: 'titleOfTheContract',
      hiddenName: 'titleOfTheContract',
    },
    // 询价单相关字段
    {
      name: 'inquiryNo',
      title: '询价单号',
      type: TEXT,
    },
    {
      name: 'groupName',
      title: '询价公司名称',
      type: TEXT,
    },
    {
      title: '询价截止日期',
      type: DateTime,
      hiddenName: 'expireDate',
      startTimeName: 'startExpireDate',
      endTimeName: 'endExpireDate',
    },
    {
      name: 'materialCount',
      title: '物料条数',
      type: SizeQuery,
      sizeQuery: {
        operatorName: 'materialCountOperator',
        numName: 'materialCount',
        ...onlyIntegerCustomProps,
        customProps: {
          selectProps: {
            options: sizeQueryOperatorEnum,
          },
        },
      },
    },
    {
      name: 'status',
      title: '状态',
      type: Hidden,
      event: 'status',
      hiddenName: 'status',
    },
    {
      name: 'itemStatus',
      title: '明细状态',
      type: Hidden,
      event: 'itemStatus',
      hiddenName: 'itemStatus',
    },
    {
      name: 'inquiryTaskNo',
      title: '来源唯一标识码',
      type: TEXT,
    },
    {
      name: 'clientMaterialName',
      title: '客方物资名称',
      type: TEXT,
    },
    {
      name: 'clientMaterialQty',
      title: '数量',
      type: SizeQuery,
      sizeQuery: {
        operatorName: 'clientMaterialQtyOperator',
        numName: 'clientMaterialQty',
        ...onlyIntegerCustomProps,
        customProps: {
          selectProps: {
            options: sizeQueryOperatorEnum,
          },
        },
      },
    },
    {
      name: 'creatorName',
      title: '创建人',
      type: 'TEXT',
    },
    {
      title: '创建日期',
      type: DateTime,
      hiddenName: 'createTimeDate',
      startTimeName: 'startCreatedTime',
      endTimeName: 'endCreatedTime',
    },
    {
      title: '截止日期',
      type: DateTime,
      hiddenName: 'deadlineTime',
      startTimeName: 'startDeadlineTime',
      endTimeName: 'endDeadlineTime',
    },
    {
      title: '物料提交时间',
      type: DateTime,
      hiddenName: 'submitTime',
      startTimeName: 'submitTimeStart',
      endTimeName: 'submitTimeEnd',
    },
    // ========== 1.6.0 项目物料模块字段 ==========
    {
      name: 'productCodes',
      title: '咸亨SKU编码',
      type: TEXT,
    },
    {
      name: 'customerSkuCodes',
      title: '客户SKU编码',
      type: TEXT,
    },
    {
      name: 'customerSpuCodes',
      title: '客户SPU编码',
      type: TEXT,
    },
    {
      name: 'customerMaterialCodes',
      title: '客户物料编码',
      type: TEXT,
    },
    {
      name: 'thirdOnShelf',
      title: '客户平台状态',
      type: Hidden,
      event: 'thirdOnShelf',
      hiddenName: 'thirdOnShelf',
    },
    {
      title: '状态变更时间',
      type: DateTime,
      hiddenName: 'thirdOnShelfChangeTime',
      startTimeName: 'thirdOnShelfStartTime',
      endTimeName: 'thirdOnShelfEndTime',
    },
    {
      name: 'supplierOrderType',
      title: '订单类型',
      type: Hidden,
      event: 'supplierOrderType',
      hiddenName: 'supplierOrderType',
    },
    // 自营协议管理筛选项
    {
      name: 'contractNo',
      title: '协议编号',
      type: TEXT,
    },
    {
      name: 'firstSigningGroupName',
      title: '甲方',
      type: TEXT,
    },
    {
      name: 'agreementSigningType',
      title: '签订方式',
      type: Hidden,
      event: 'agreementSigningType',
      hiddenName: 'agreementSigningType',
    },
    {
      name: 'agreementSignStatus',
      title: '协议签署状态',
      type: Hidden,
      event: 'agreementSignStatus',
      hiddenName: 'agreementSignStatus',
    },
    {
      name: 'agreementStatus',
      title: '协议状态',
      type: Hidden,
      event: 'agreementStatus',
      hiddenName: 'agreementStatus',
    },
    {
      title: '协议有效期',
      type: DateTime,
      hiddenName: 'effective',
      startTimeName: 'effectiveStart',
      endTimeName: 'effectiveEnd',
    },
    {
      name: 'untilContractExpirationDays',
      title: '距离到期天数',
      type: SizeQuery,
      sizeQuery: {
        operatorName: 'untilContractExpirationDaysOperators',
        numName: 'untilContractExpirationDays',
        ...onlyIntegerCustomProps,
        customProps: {
          selectProps: {
            options: sizeQueryOperatorEnum,
          },
        },
      },
    },
    // ========== MPM v5.0.0 项目商品池字段（固定 7 项） ==========
    { name: 'poolProductCode', title: '咸亨编码', type: TEXT },
    { name: 'poolCustomerTitle', title: '客户标题', type: TEXT },
    { name: 'poolBrandName', title: '品牌名称', type: TEXT },
    { name: 'poolCategoryName', title: '类目名称', type: TEXT },
    { name: 'poolRemark', title: '备注', type: TEXT },
    { name: 'poolStandardCode', title: '标准库编码/产品编码', type: TEXT },
    { name: 'poolMaterialCode', title: '物资编码', type: TEXT },
  ]
}
// 方案类型 区分不同模块的方案数据
export const SchemeType = [
  { title: 'SUPPLIERLIST', type: '2' },
  { title: 'INTERNATIONSUPPLIERLIST', type: '6' },
  { title: 'BLACKLIST', type: '7' },
  { title: 'REGISTERWAITAUDIT', type: '15' },
  { title: 'REGISTERAUDITRECORD', type: '4' },
  { title: 'REGISTERSUPPLIERACCOUNT', type: '5' },
  { title: 'MANAGEMYAPPLICATION', type: '8' },
  { title: 'MANAGEWAITAUDIT', type: '9' },
  { title: 'MANAGEAUDITRECORD', type: '10' },
  { title: 'CONTRACTLIST', type: '1' },
  { title: 'METTINGLIST', type: '11' },
  { title: 'ENQUIRYLIST', type: '3' },
  { title: 'ORGMANAGE', type: '14' },
  { title: 'DEPTMANAGE', type: '13' },
  { title: 'USERMANAGE', type: '12' },
  { title: 'BRAND', type: '16' },
  { title: 'AUTHORIZATION', type: '17' },
  { title: 'ACCOUNT', type: '18' },
  { title: 'LAUNCHGOODS', type: '19' },
  { title: 'ORDERASSURANCE', type: '20' },
  { title: 'RETURNMANAGEMENT', type: '21' },
  { title: 'ORDERREGISTRATION', type: '22' },
  { title: 'FINANCIALRECONCILIATION', type: '23' },
  { title: 'ACCOUNTDONEORDER', type: '24' },
  { title: 'SUPPLIERORDERASSURANCE', type: '28' },
  { title: 'SUPPLIERORDERRETURN', type: '29' },
  { title: 'MESSAGECENTER', type: '32' },
  // { title: 'ADDINVOICE', type: '33' },
  // 开票申请
  { title: 'INVOICEAPPLICATION', type: '34' },
  // 可对账订单
  { title: 'RECONCILABLEORDERS', type: '33' },
  { title: 'PAYABLEORDERS', type: '35' },
  { title: 'PAYMENTREQUEST', type: '36' },
  { title: 'LAUNCHBRAND', type: '37' },
  { title: 'XHANNOUNCEMENT', type: '37' },
  { title: 'LANDERINVOICEENTRY', type: '41' },
  { title: 'SUPPLIERINVOICEENTRY', type: '48' },
  { title: 'MYINVOICE', type: '40' },
  { title: 'RELEVANCEBUYER', type: '42' },
  { title: 'INVENTORYMANAGEMENT', type: '46' },
  { title: 'MATERIALPRICEADJUSTMENT', type: '47' },
  // 电商供应商合同
  { title: 'LOCALCONTRACT', type: '38' },
  { title: 'MATERIALSUBMISSION', type: '49' },
  {
    title: 'REDLANDERINVOICEENTRY',
    type: '50',
  },
  {
    title: 'INQUIRYLIST',
    type: '51',
  },
  {
    title: 'MATERIALCODEMODAL',
    type: '56',
  },
  {
    title: 'TODOLIST',
    type: '57',
  },
  {
    title: 'PROJECTMATERIAL',
    type: '58',
  },
  // MPM v5.0.0 项目商品池（页面隐藏方案，编号仅作占位）
  {
    title: 'PROJECTPOOL',
    type: '81',
  },
  // 自营协议管理
  {
    title: 'SELFAGREEMENT',
    type: '59',
  },
] as const
export const SelectCheckBox = [
  'enterpriseNature',
  'platformCodes',
  'srmPlatformCodes',
  'signingType',
  'platformCode',
  'status',
  'supplierOrderType',
]

// 要求时间为毫秒数的参数
export const startTimeStampArr: formName[] = [
  'orderTimeStart',
  'dispatchTimeStart',
  'reportStartTime',
  'auditStartTime',
  'returnStartTime',
  'startExpireDate',
  'inquiryStartDate',
  'quotationTimeStart',
  'startCreatedTime',
  'startDeadlineTime',
  'inquiryDateStart',
  'thirdOnShelfStartTime',
  'effectiveStart',
]
export const endTimeStampArr: formName[] = [
  'orderTimeEnd',
  'dispatchTimeEnd',
  'reportEndTime',
  'auditEndTime',
  'returnEndTime',
  'endExpireDate',
  'inquiryEndDate',
  'quotationTimeEnd',
  'endCreatedTime',
  'endDeadlineTime',
  'inquiryDateEnd',
  'thirdOnShelfEndTime',
  'effectiveEnd',
]

export type ScreenKey = (typeof SchemeType)[number]['title']
// export type ScreenKey =
//   // 国内供应商列表
//   | 'SUPPLIERLIST'
//   // 国际供应商列表
//   | 'INTERNATIONSUPPLIERLIST'
//   // 黑名单
//   | 'BLACKLIST'
//   // 前台-待审核
//   | 'REGISTERWAITAUDIT'
//   // 前台-审核记录
//   | 'REGISTERAUDITRECORD'
//   // 前台-供应商账号
//   | 'REGISTERSUPPLIERACCOUNT'
//   // 后台-我的申请
//   | 'MANAGEMYAPPLICATION'
//   // 后台-待我审核
//   | 'MANAGEWAITAUDIT'
//   // 后台-审核记录
//   | 'MANAGEAUDITRECORD'
//   // 合同列表
//   | 'CONTRACTLIST'
//   // 会议列表
//   | 'METTINGLIST'
//   // 记录列表
//   | 'ENQUIRYLIST'
//   // 组织管理
//   | 'ORGMANAGE'
//   // 部门管理
//   | 'DEPTMANAGE'
//   // 用户管理
//   | 'USERMANAGE'
//   // 品牌
//   | 'BRAND'
//   // 品牌授权
//   | 'AUTHORIZATION'
//   //
//   | 'ACCOUNT'
//   | 'LAUNCHGOODS'
//   | 'ORDERASSURANCE'
//   | 'RETURNMANAGEMENT'
//   | 'ORDERREGISTRATION' // 报备单
//   | 'FINANCIALRECONCILIATION' // 对账单
//   | 'ACCOUNTDONEORDER' // 对账单 已验收订单
//   | 'SUPPLIERORDERASSURANCE' // 供应商订单
//   | 'SUPPLIERORDERRETURN' // 供应商退货
//   | 'MESSAGECENTER' // 消息中心
//   // 这个取消，和开票申请用同一份
//   // | 'ADDINVOICE' //申请开票
//   // 开票申请
//   | 'INVOICEAPPLICATION'
//   | 'RECONCILABLEORDERS'
//   // 可付款订单列表
//   | 'PAYABLEORDERS'
//   // 付款申请列表
//   | 'PAYMENTREQUEST'
//   | 'LAUNCHBRAND'
//   | 'XHANNOUNCEMENT'
//   | 'LANDERINVOICEENTRY'
//   | 'SUPPLIERINVOICEENTRY'
//   | 'MYINVOICE'
//   | 'RELEVANCEBUYER'
//   | 'INVENTORYMANAGEMENT'
//   | 'MATERIALPRICEADJUSTMENT' // 国网物料调价
//   | 'LOCALCONTRACT' // 合同管理
//   | 'MATERIALSUBMISSION' // 项目物料提报管理
//   // 红票录入
//   | 'REDLANDERINVOICEENTRY'
